export const actionTypes = {
  PAYROLL_DEDUCTIONS_SUCCESS: 'PAYROLL_DEDUCTIONS_SUCCESS',
  PAYROLL_DEDUCTIONS_FAILURE: 'PAYROLL_DEDUCTIONS_FAILURE',
  PAYROLL_DEDUCTIONS_LOADER: 'PAYROLL_DEDUCTIONS_LOADER',

  ADD_NEW_DEDUCTIONS_SUCCESS: 'ADD_NEW_DEDUCTIONS_SUCCESS',
  ADD_NEW_DEDUCTIONS_FAILURE: 'ADD_NEW_DEDUCTIONS_FAILURE',
  ADD_NEW_DEDUCTIONS_LOADER: 'ADD_NEW_DEDUCTIONS_LOADER',

  DELETE_DEDUCTION_SUCCESS: 'DELETE_DEDUCTION_SUCCESS',
  DELETE_DEDUCTIONS_FAILURE: 'DELETE_DEDUCTIONS_FAILURE',
  DELETE_DEDUCTIONS_LOADER: 'DELETE_DEDUCTIONS_LOADER',

  GET_AUDIT_HISTORY_SUCCESS: 'GET_AUDIT_HISTORY_SUCCESS',
  GET_AUDIT_HISTORY_FAILURE: 'GET_AUDIT_HISTORY_FAILURE',
  GET_AUDIT_HISTORY_LOADER: 'GET_AUDIT_HISTORY_LOADER',

  ADD_EXEMPTIONS_SUCCESS: 'ADD_EXEMPTIONS_SUCCESS',
  ADD_EXEMPTIONS_FAILURE: 'ADD_EXEMPTIONS_FAILURE',
  ADD_EXEMPTIONS_LOADER: 'ADD_EXEMPTIONS_LOADER',

  SUBMIT_EXEMPTIONS_SUCCESS: 'SUBMIT_EXEMPTIONS_SUCCESS',
  SUBMIT_EXEMPTIONS_FAILURE: 'SUBMIT_EXEMPTIONS_FAILURE',
  SUBMIT_EXEMPTIONS_LOADER: 'SUBMIT_EXEMPTIONS_LOADER',

  RESET_EXEMPTION_LIST: 'RESET_EXEMPTION_LIST',

  VIEW_AUDIT_SUCCESS: 'VIEW_AUDIT_SUCCESS',
  VIEW_AUDIT_FAILURE: 'VIEW_AUDIT_FAILURE',
  VIEW_AUDIT_LOADER: 'VIEW_AUDIT_LOADER',

  GET_EMPLOYEES_LIST_SUCCESS: 'GET_EMPLOYEES_LIST_SUCCESS',
  GET_EMPLOYEES_LIST_FAILURE: 'GET_EMPLOYEES_LIST_FAILURE',
  GET_EMPLOYEES_LIST_LOADER: 'GET_EMPLOYEES_LIST_LOADER',
};
